import { useTranslation } from 'react-i18next';
import { CATEGORIES } from '@/mocks/categories';

export default function CategoriesSection() {
  const { t } = useTranslation('common');

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            {t('categories.h2')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {CATEGORIES.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.img}
                  alt={t(cat.key)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors text-center">
                  {t(cat.key)}
                </h3>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            {t('categories.cta')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}